import '@babel/polyfill'

import Vue from 'vue'
import App from './App.vue'
import router from './router/index'
import store from './store/index'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'

import ElementUI from 'element-ui'
import 'assets/style/common.scss'
import * as filters from '@/filters' // global filters
import animated from 'animate.css'
// import customui from 'custom-private-ui'
import VueLazyload from 'vue-lazyload'
import admContact from '@/components/admContact'

//引入视频video.js插件
import Video from "video.js";
import "video.js/dist/video-js.css";

//引入云上展及数智纺导航栏公共组件
import vHeader from '@/components/Header'
import fHeader from "@/components/fateHeader";
import vRheader from "@/components/vrHeader";
// 引入（seo优化）
import MetaInfo from 'vue-meta-info'
// 使用（seo优化）
Vue.use(MetaInfo)
// customui.install(Vue)

//使用video.js插件
Vue.prototype.$video = Video;

Vue.use(animated)
Vue.component('admcontact', admContact)
//全局注册导航栏
Vue.component("v-header", vHeader);
Vue.component("f-header", fHeader);
Vue.component("v-rheader", vRheader);

Vue.use(VueAwesomeSwiper /* { default options with global component } */ )
Vue.use(VueLazyload)
// 配置项
// Vue.use(VueLazyload, {
//   preLoad: 1.3,
//   error: 'dist/error.png',
//   loading: 'dist/loading.gif',
//   attempt: 1
// })
Vue.use(ElementUI, {
  size: 'small',
  zIndex: 3000
})

Vue.config.productionTip = false

// register global utility filters
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})

router.beforeEach((to, from, next) => {
  // document.title = to.meta.title
  // next()
  if (to.meta.content) {
    let head = document.getElementsByTagName('head')
    let meta = document.createElement('meta')
    // console.log(document.querySelector('meta[name="keywords"]'))
    document.querySelector('meta[name="keywords"]').setAttribute('content', to.meta.content.keywords)
    document.querySelector('meta[name="description"]').setAttribute('content', to.meta.content.description)
    meta.content = to.meta.content
    head[0].appendChild(meta)
  }
  if (to.meta.title) {
    document.title = to.meta.title
  }
  next()
})

router.afterEach((to, from) => {
  let bodySrcollTop = document.body.scrollTop
  if (bodySrcollTop !== 0) {
    document.body.scrollTop = 0
    return
  }
  let docSrcollTop = document.documentElement.scrollTop
  if (docSrcollTop !== 0) {
    document.documentElement.scrollTop = 0
  }
})

new Vue({
  router,
  store,
  render: h => h(App),
  // (seo优化)需要加上下面这个东西
  mounted() {
    document.dispatchEvent(new Event('render-event')) // 需要加上
  }
}).$mount('#app')
